import { GuestLinkDataResponseDto } from '@lucidlink/dto/web-service-api';
import { parserFromDto } from '#fetcher/parse-utils';
import { TimeCachedValue } from '#sdk/utils/time-cached-value';
import { NotLoggedInWithGuestLinkError, } from '#session/session-manager';
import { createWorkspaceClient } from '../workspace-client';
export const createGuestClient = ({ linkId, logger, additionalInfo, getSessionManager, getGlobalFetcher, getGlobalTelemetryClient, }) => {
    return new GuestClientImpl(linkId, logger, additionalInfo, getSessionManager, getGlobalFetcher, getGlobalTelemetryClient);
};
export class GuestClientImpl {
    linkId;
    logger;
    additionalInfo;
    getSessionManager;
    getGlobalFetcher;
    getGlobalTelemetryClient;
    // NOTE: Guest Links are only for a specific folder in a specific filespace,
    //       therefore no need for handling multiple workspace/filespace combinations
    workspaceClient;
    guestClientFetcher;
    constructor(linkId, logger, additionalInfo, getSessionManager, getGlobalFetcher, getGlobalTelemetryClient) {
        this.linkId = linkId;
        this.logger = logger;
        this.additionalInfo = additionalInfo;
        this.getSessionManager = getSessionManager;
        this.getGlobalFetcher = getGlobalFetcher;
        this.getGlobalTelemetryClient = getGlobalTelemetryClient;
    }
    async login(secret) {
        const { workspaceId, filespaceId } = await this.getLinkData();
        if (!this.workspaceClient) {
            this.workspaceClient = createWorkspaceClient({
                workspaceId,
                getSessionManager: this.getSessionManager,
                getGlobalFetcher: this.getGlobalFetcher,
                logger: this.logger,
                getGlobalTelemetryClient: this.getGlobalTelemetryClient,
                additionalInfo: this.additionalInfo,
                getClassicApiContext: () => Promise.resolve(undefined),
            });
        }
        await this.workspaceClient.guestLogin(secret, this.linkId);
        return this.workspaceClient.filespaceLogin(filespaceId);
    }
    async logout() {
        if (!this.workspaceClient) {
            return;
        }
        await this.workspaceClient.logout();
        this.linkParameters.reset();
        this.workspaceClient = undefined;
    }
    async getLinkData() {
        return this.linkParameters.get();
    }
    async getFilespace() {
        const { filespaceId, workspaceId } = await this.getLinkData();
        if (!this.workspaceClient) {
            throw new NotLoggedInWithGuestLinkError(this.linkId, workspaceId);
        }
        return this.workspaceClient.getFilespace(filespaceId);
    }
    linkParameters = new TimeCachedValue(async () => this.getGuestClientFetcher().get([], {
        parser: parserFromDto(GuestLinkDataResponseDto),
    }), {
        expirationTime: 'neverExpire',
    });
    getGuestClientFetcher() {
        if (!this.guestClientFetcher) {
            this.guestClientFetcher = this.getGlobalFetcher().createSubFetcher({
                path: ['guest-links', this.linkId],
                getAccessToken: (forceRefresh) => this.getSessionManager().getFreshGlobalToken(forceRefresh),
            });
        }
        return this.guestClientFetcher;
    }
}
